module.exports = __webpack_public_path__ + "public/img/zfb.e103a7e3.png";